import { Button, Flex } from '@chakra-ui/react'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

export const Navigation = ({ links }) => {
  const location = useLocation()

  function getActiveLink(path) {
    return location.pathname.includes(path) ? 'active' : ''
  }

  return (
    <Flex alignItems="center" gap={2} w="full" justifyContent="center" mt={3}>
      <Button colorScheme="blue" size="sm" variant={getActiveLink('home') ? 'solid' : 'outline'} as={Link} to="/adm/responde/home/cadastro-pergunta">
        Home
      </Button>
      <Button
        colorScheme="blue"
        as={Link}
        size="sm"
        variant={getActiveLink('produto') ? 'solid' : 'outline'}
        to={{
          pathname: '/adm/responde/produto/1/cadastro-pergunta',
          state: { id: 1 },
        }}
      >
        Produto
      </Button>
      <Button
        colorScheme="blue"
        size="sm"
        variant={getActiveLink('categoria') ? 'solid' : 'outline'}
        as={Link}
        to="/adm/responde/categoria/cadastro-pergunta"
      >
        Categoria
      </Button>
      <Button
        colorScheme="blue"
        size="sm"
        variant={getActiveLink('segmento') ? 'solid' : 'outline'}
        as={Link}
        to="/adm/responde/segmento/cadastro-pergunta"
      >
        Segmento
      </Button>
      <Button
        colorScheme="blue"
        size="sm"
        variant={getActiveLink('ultra-rapido') ? 'solid' : 'outline'}
        as={Link}
        to="/adm/responde/ultra-rapido/cadastro-pergunta"
      >
        Ultra Rápido
      </Button>
    </Flex>
  )
}
